import React from 'react'
import TopMenuBar from '../components/TopMenuBar'
import bannerImage from '../../../assets/C9496F87-E65B-4394-B181-1F50FEB7D676.png'
import './FeaturePage.css';

export const FeaturePage = () => {
  return (
    <>
    <div><TopMenuBar /></div>
    <header className="banner-container">
      <div className="text-section">
        <h1>Turn What You Have Into What You Crave!</h1>
        <p>Simplify mealtime with SousPal! Scan your food items to discover recipes tailored to your pantry...</p>
      </div>
      <div className="image-section">
        <img src={bannerImage} alt="Banner" />
      </div>
    </header>
    
    <main className="features-section">
        <h2>Our Features</h2>
        <div className="features-container">
          <div className="feature-column">
            <ul>
              <li>✔️ Track food and ingredients: Whether you're at home planning a meal or at the store trying to remember if you're low on an item.</li>
            </ul>
            <ul>
              <li>✔️ Track nutrition: Have SousPal gather the nutritional information based on the recipes used.</li>
            </ul>
          </div>
          <div className="feature-column">
            <ul>
              <li>✔️ Personalized Recipes: Have access to thousands of recipes and be able to filter based on the ingredients in your house.</li>
            </ul>
            <ul>
              <li>✔️ Food Alerts: Get alerted when items are about to expire and be provided recipes based on that ingredient to help cut down food waste and save money.</li>
            </ul>
          </div>
          <div className="feature-column">
            <ul>
              <li>✔️ Invite household members: Allow household members to add ingredients, look at recipes, and vote for meals.</li>
            </ul>
            <ul>
              <li>✔️ Poll Voting: Send push notifications to household members to vote on recipes.</li>
          </ul>
          </div>
        </div>
    </main>
    </>
    
  )
}
